export default __webpack_public_path__ + "static/How Personalised Learning Platforms-b1b6d20335fac9a51984a9d57b10fc04.jpg";